import { Typography } from "antd";
import styles from "./candidateFieldValue.module.scss";

const { Text } = Typography;

export const CandidateFieldValue = ({ children }) => {
  return <Text className={styles.fieldValue}>{children}</Text>;
};
